/* Import global components */
import { navigationFooterQuery } from '../blocks/navigation-footer/NavigationFooter.query.wp';
import { navigationMainQuery } from '../blocks/navigation-main/NavigationMain.query.wp';
import { heroCtaGlobalQuery } from '../blocks/hero-cta/HeroCta.query.wp';
import { heroHomeGlobalQuery } from '../blocks/hero-home/HeroHome.query.wp';

export function getCompiledGlobalQuery() {
  return `
        query GetGlobalData {
            ${navigationFooterQuery}
            ${navigationMainQuery}
            ${heroCtaGlobalQuery}
            ${heroHomeGlobalQuery}
            }
        `;
}
